































import { Component, Vue } from 'vue-property-decorator';
import { Getter } from 'vuex-class'
import { USER_REAL_ID, USERNAME} from "@/modules/auth/store/constants";

@Component({
    components: {
    },
})
export default class Contests extends Vue {
    @Getter(USER_REAL_ID) userRealId!: string;
    @Getter(USERNAME) userName!: string;

    private get userId() {
        return this.userRealId.split('/')[1]
    }
    private mounted() {
        // this.fetchContestList();
    }

    get selectedTab() {
        return this.$route.name;
    }

}
